export default "assets/images/small_logo_black-fba86bd6.svg";